import React from 'react';
import {reach} from '@hapi/hoek';
import CategoryWrapper from 'components/CategoryWrapper/CategoryWrapper';
import PageMeta from 'components/PageMeta/PageMeta';
import HeroHeader from 'components/HeroHeader/HeroHeader';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import CardCarousel from 'components/CardCarousel/CardCarousel';
import FeaturedArticlesSection from 'components/FeaturedArticlesSection/FeaturedArticlesSection';
import FeaturedCallOutsSection from 'components/FeaturedCallOutsSection/FeaturedCallOutsSection';
import RelatedArticles from 'components/RelatedArticles/RelatedArticles';
import JsonSchema from './CategoryJsonSchema';
import {getBreadcrumbs} from 'utils/utils';

const LoadedCategory = (props) => {
    const {
        systemData,
        allCategories,
        translations,
        response,
        homeRoute,
        isMobile,
    } = props;
    const {isTablet, hostname, basePath} = systemData;
    const isDevice = isMobile || systemData.isMobile || isTablet;
    const commonProps = {
        isDevice,
        translations,
    };
    const {
        data: {categoryCollection, subcategories},
    } = response;

    const category = reach(categoryCollection, 'items.0');
    const featuredArticles = reach(
        category,
        'featuredArticlesCollection.items',
    );
    const externalLinkCarousel = reach(category, 'externalLinkCarousel') || {};

    const canonical = `https://${hostname}${basePath}${homeRoute}${category.path}`;
    const crumbs = getBreadcrumbs(
        allCategories,
        {
            name: category.partition ? null : translations.home,
            url: homeRoute,
        },
        category,
    );

    return (
        <CategoryWrapper>
            <PageMeta
                metaTitle={category.metaTitle}
                metaDescription={category.metaDescription}
                canonical={canonical}
                hreflangData={category.hreflang}
                heroFile={category.image}
                {...{systemData}}
            />
            <JsonSchema
                homeRoute={homeRoute}
                systemData={systemData}
                featuredArticles={featuredArticles}
                category={category}
                canonical={canonical}
            />
            <HeroHeader
                title={category.headline}
                content={category.introduction}
                metaDescription={category.metaDescription}
                renderedCrumbs={
                    <Breadcrumbs crumbs={crumbs} hostname={hostname} />
                }
            />
            <CardCarousel
                title={translations.browseBySubcategory}
                cards={subcategories.items}
                {...commonProps}
            />
            <FeaturedArticlesSection
                title={category.featuredArticlesTitle}
                articles={featuredArticles}
                {...commonProps}
            />
            <FeaturedCallOutsSection
                callOuts={reach(category, 'callOutsCollection.items')}
                {...commonProps}
            />
            <CardCarousel
                title={externalLinkCarousel.title}
                cards={reach(
                    externalLinkCarousel,
                    'externalLinksCollection.items',
                )}
                {...commonProps}
            />
            <RelatedArticles
                title={translations.exploreArticles}
                category={category.sys.id}
                systemData={systemData}
                {...commonProps}
            />
        </CategoryWrapper>
    );
};

export default LoadedCategory;
